import React from 'react';

export const SponsorButton = ({ style }) => {
  // eslint-disable-next-line max-len
  const buttonIframe = '<iframe src="https://github.com/sponsors/manuelmhtr/button" title="Sponsor this project" height="35" width="116" style="border: 0;"></iframe>';

  return (
    // eslint-disable-next-line react/no-danger
    <div style={style} dangerouslySetInnerHTML={{ __html: buttonIframe }} />
  );
};
